"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEntrypoint = void 0;
const initializer_1 = require("../../initializer");
const utils_1 = require("./utils");
const renderApp_1 = require("./renderApp");
const mobileConnector_1 = require("../../mobileConnector");
// providers
const translations_1 = require("../../translations");
const eventBus_1 = require("../../eventBus");
const tracker_1 = require("../../tracker");
const uiInformation_1 = require("../../uiInformation");
// types
const libraries_1 = require("../../libraries");
const buildEntrypoint = ({ App, XHRTracker, API, translationsConfig, trackerConfig, mobileConnectorConfig, libraries, }) => async (domElement, store, history, initializedFeatures, externalComponents, data) => {
    const asyncInitQueue = [];
    (0, utils_1.restartSession)(data.sessionData);
    (0, utils_1.initCache)(data.cacheData);
    const isMobileCommunicatorInitialized = await (0, mobileConnector_1.initMobileCommunicator)(initializer_1.Session, mobileConnectorConfig);
    if (isMobileCommunicatorInitialized) {
        await initializer_1.HybridAuthenticator.login();
    }
    (0, utils_1.initFeatureFlags)(data.featureFlag);
    (0, eventBus_1.setGlobalEventBus)(data.eventBus);
    if (trackerConfig) {
        await (0, tracker_1.initAllTrackers)(trackerConfig, XHRTracker, initializer_1.GenericUSDManager, initializer_1.Authenticator);
        tracker_1.trackers.tealiumTracker && asyncInitQueue.push((0, tracker_1.addCommonInfoToTealiumTracker)(trackerConfig));
    }
    asyncInitQueue.push((0, libraries_1.initLibraries)(libraries));
    asyncInitQueue.push((0, uiInformation_1.initDeviceUUID)());
    if (translationsConfig) {
        asyncInitQueue.push((0, translations_1.initTranslationsWithInitialTranslationsAndConfig)(API, translationsConfig, data.translations?.web, data.translations?.config));
    }
    try {
        await Promise.all(asyncInitQueue);
    }
    catch (error) {
        console.error(error);
        console.error('Can`t initiate feature flag or translations. Check network');
    }
    (0, renderApp_1.renderApp)({
        App,
        history: data.history,
        defaultHistory: history,
        store,
        initializedFeatures,
        externalComponents,
        domElement,
    });
};
exports.buildEntrypoint = buildEntrypoint;
//# sourceMappingURL=buildEntrypoint.js.map